/**
 * サマリー・合計の % を小数 2 桁の文字列にする。 値なし (ゼロ除算) は「0.0」。
 * docs/specs/conventions.md「数値表示」。 単位 (%) は呼び出し側が持つ。
 */
export function formatPctSum(value: number | undefined): string {
  return value === undefined ? '0.0' : value.toFixed(2)
}
